/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Complete_Registration_TitleInputs */

const de_login_complete_registration_title = /** @type {(inputs: Login_Complete_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil vervollständigen`)
};

/** @type {(inputs: Login_Complete_Registration_TitleInputs) => LocalizedString} */
const en_login_complete_registration_title = de_login_complete_registration_title;

/**

* @param {Login_Complete_Registration_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_complete_registration_title = /** @type {((inputs?: Login_Complete_Registration_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Complete_Registration_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_complete_registration_title(inputs)
	return en_login_complete_registration_title(inputs)
});